module.exports = __webpack_public_path__ + "assets/Mu.6a2ae3f25e57203bc4dc831ebcd6c791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Mu.png
// module id = 838
// module chunks = 0